// app/javascript/controllers/tabs_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["btn", "tab"]
  static values = { defaultTab: String }

  // connect() is called when the controller is connected to the DOM
  //
  // It starts by hiding all tabs to prevent multiple tabs to be visible, then
  // shows the default tab.
  connect() {
    this.hideAllTabs()
    this.showTab(this.getTab(this.defaultTabValue))
    this.activateButton(this.getButton(this.defaultTabValue))
  }

  // Switch between tabs
  // add to your buttons: data-action="click->tabs#select"
  select({ params: { tabId } }) {
    // Flush pending autosave before switching context-heavy tabs like "execute".
    document.dispatchEvent(new CustomEvent("autosave:flush", { bubbles: true }))

    let selectedTab = this.getTab(tabId)
    if (selectedTab.hidden) {
      this.hideAllTabs()
      this.deactivateAllButtons()

      this.showTab(selectedTab)
      this.activateButton(this.getButton(tabId))
    } else {
      // the code below enables showing no tabs
      // clicking on an active tab will close it, hiding everything
      this.hideAllTabs()
      this.deactivateAllButtons()
    }
  }

  showTab(tab) {
    tab.hidden = false
  }

  hideTab(tab) {
    tab.hidden = true
  }

  activateButton(button) {
    button.classList.add('active')
    button.setAttribute('aria-current', 'page')
  }

  deactivateButton(button) {
    button.classList.remove('active')
    button.removeAttribute('aria-current')
  }

  hideAllTabs() {
    this.tabTargets.map(this.hideTab)
  }

  deactivateAllButtons() {
    this.btnTargets.map(this.deactivateButton)
  }

  getTab(tabId) {
    return this.tabTargets.find(element => element.id === tabId)
  }

  getButton(tabId) {
    return this.btnTargets.find(element => element.dataset.tabsTabIdParam === tabId)
  }
}
